import React from "react";
import styled from "styled-components";
import colours from "../../lib/colours";
import { ReactComponent as TreeIcon } from "../../assets/svg/tree.svg";
import { ReactComponent as PolygonSketchIcon } from "../../assets/svg/polygonSketch.svg";
import { ReactComponent as ArrowRightIcon } from "../../assets/svg/arrow-right.svg";
import { featureTypes } from "../../lib/types";

const iconSources: Record<string, any> = {
  polygon: PolygonSketchIcon,
  point: TreeIcon,
};

const iconStyle = {
  color: colours.th2d1,
};

const iconStyles: Record<string, any> = {
  polygon: { ...iconStyle },
  point: { position: "relative", left: "1px", ...iconStyle },
};

const Container = styled.button`
  display: flex;
  width: 100%;
  height: 48px;
  align-items: center;
  border: none;
  font-weight: 300;
  cursor: pointer;
  padding-inline: 12px;
  background-color: ${colours.white};
  color: ${colours.th1};

  &:hover {
    background-color: ${colours.offWhite};
  }
`;

const ContainerActive = styled(Container)`
  background-color: ${colours.th2l1};
  &:hover {
    background-color: ${colours.th2l1};
  }
`;

const TextContainer = styled.div`
  flex: 1;
  font-size: 16px;
  text-align: left;
  padding-inline: 10px;
  font-weight: 600;
`;

interface IProps {
  optionId: featureTypes;
  name: string;
  icon: string;
  active: boolean;
  onActivate: any;
}

const DrawOption = ({ optionId, name, icon, active, onActivate }: IProps) => {
  const IconElement = iconSources[icon];
  const ContainerElement = active ? ContainerActive : Container;
  return (
    <ContainerElement onClick={() => onActivate(optionId)}>
      <IconElement style={iconStyles[icon]} />
      <TextContainer>{name}</TextContainer>
      <ArrowRightIcon style={{ height: "16px", width: "16px" }} />
    </ContainerElement>
  );
};

export default DrawOption;
